export default __webpack_public_path__ + "static/media/ISMO CLASS-4_SYLLABUS_2025-26.dc657456.pdf";